import React from 'react';

// import styles from 'styles/icon.css';
import styles from '../styles/icon.css';

interface IconProps {
  size?: number;
  fill?: string;
}

const LayersIcon: React.FC<IconProps> = props => {
  // const colorFill = props.fill || '#5AB8F1';
  // const size = props.size || 26;

  return (
    <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="24 / basic / layers">
        <g id="Stockholm icons / Design / Layers">
          <path
            id="Shape"
            d="M14.0116 17.4118L20.9736 11.8695L21.1449 11.7338C21.8485 11.1766 21.9672 10.1546 21.4101 9.45104C21.3329 9.35362 21.2449 9.26536 21.1476 9.18801L14.0117 3.51273C13.4196 3.04182 12.5808 3.04182 11.9887 3.51273L4.84795 9.1919C4.14554 9.75054 4.02899 10.7728 4.58762 11.4752C4.66397 11.5712 4.75093 11.6582 4.84686 11.7347L5.01605 11.8695L11.9883 17.4124C12.5806 17.8833 13.4196 17.8831 14.0116 17.4118Z"
            // fill={colorFill}
            className={styles.iconSvgPath}
          />
          <path
            id="Path"
            opacity="0.3"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11.978 20.2266L5.78089 15.2998C5.35796 14.9636 4.74255 15.0339 4.40632 15.4568C4.40374 15.4601 4.40117 15.4633 4.39863 15.4666C4.06558 15.8967 4.14423 16.5153 4.57429 16.8484C4.57585 16.8496 4.57741 16.8508 4.57898 16.852L12.0115 22.5367C12.5941 22.9824 13.403 22.9824 13.9857 22.5369L21.4154 16.8565C21.8504 16.5239 21.9334 15.9017 21.6008 15.4666C21.5994 15.4648 21.598 15.4629 21.5965 15.4611C21.2625 15.0306 20.6428 14.9524 20.2123 15.2864C20.2092 15.2888 20.2061 15.2912 20.203 15.2937L14.0008 20.2264C13.4087 20.6973 12.5701 20.6973 11.978 20.2266Z"
            // fill={colorFill}
            className={styles.iconSvgPath}
          />
        </g>
      </g>
    </svg>
  );
};

export default LayersIcon;
